export default {
  app: {
    title: 'Axial Next',
    contact: 'Kérdése van? Írjon:'
  },

  pages: {
    index: 'Kezdőlap'
  },

  errorPage: {
    title: '404',
    description: 'A keresett oldal nem található',
    homeBtn: 'Vissza a főoldalra'
  },

  menu: {
    ownParcels: 'Összes tábla',
    tenders: 'Projektek',
    offers: 'Pályázatok',
    parcels: 'Projekt táblái',
    logout: 'Kijelentkezés',
    personalData: 'Személyes adatok',
    services: 'Projekt szolgáltatásai',
    videoHelp: 'Videós segédletek',
    helpDoc: 'Segédletek',
    tocDoc: 'ÁSZF',
    maximapModule: 'mAXI-MAP előfizetés',
    webshopOrders: 'Webshopos rendelés',
    webshopOrdersSubtitle: 'Pályázattól független rendelések',
    general: 'Fiók és támogatás'
  },
  order: {
    status: {
      orderable: 'Rendelhető',
      notOrderable: 'Nem rendelhető',
      created: 'Megrendelve',
      inProgress: 'Folyamatban',
      completed: 'Teljesítve',
      canceled: 'Lezárt'
    },
    label: {
      productGroupName: 'Csomag neve',
      services: 'Szolgáltatások',
      orderDate: 'Megrendelés dátuma',
      completeDate: 'Teljesítés dátuma',
      parcels: 'Táblák',
      close: 'Lezárás'
    },
    services: {
      unit: {
        piece: 'db',
        hectare: 'ha'
      }
    },
    parcels: {
      all: 'A Gazdaság összes táblája'
    },
    dialog: {
      title: 'Csomag rendelés',
      closeTitle: 'Csomag lezárása',
      confirmOrderTitle: 'Megrendelés megerősítése',
      parcels: {
        title: 'Szolgáltatáshoz tartozó táblák',
        emptyParcels: 'A szolgáltatáshoz nem tartozik tábla.'
      }
    },
    filter: {
      status: 'Státusz',
      year: 'Rendelés éve'
    },
    notification: {
      orderSuccess: 'Sikeres megrendelés! A megrendelt szolgáltatások tabon követheti nyomon a rendelése állapotát.',
      closeOrderSuccess: 'Sikeres lezárás!',
      orderError: 'Hiba történt a megrendelés során!',
      closeOrderError: 'Hiba történt a lezárás során!'
    },
    completeParcels: 'Kérjük véglegesítse a rögzített Táblákat',
    beforeImplementation: {
      currentYear: 'A pályázat megkezdése ebben az évben',
      note: 'A pályázat megvalósításához ebben az évben az összes pályázott csomagot meg kell rendelni az igényelt hektár mennyiségben.'
    }
  },

  offer: {
    list: {
      title: 'Projektek',
      notification: {
        requestContractSuccess: 'Szállítási megállapodás igénylése sikeres',
        requestContractError: 'Szállítási megállapodás igénylése sikertelen',
        requestNewOfferSuccess:
          'Az új projekt igénylése sikeresen megtörtént. Értesítettük a területi képviselőjét az igény bejelentésről.',
        requestNewOfferError: 'Hiba történt az új projekt igénylése közben!'
      }
    },
    details: {
      baseData: 'Alapadatok',
      parcels: 'Táblák',
      products: 'Szolgáltatások',
      orderableProducts: 'Rendelhető szolgáltatások',
      orderedProducts: 'Megrendelt szolgáltatások',
      extra: 'Keretszerződés',
      label: {
        id: 'Azonosító',
        definedArea: 'Rögzített terület',
        name: 'Név',
        address: 'Cím',
        taxNumber: 'Adószám',
        farmName: 'Gazdaság',
        partnerName: 'Kapcsolattartó neve',
        partnerEemail: 'Email cím',
        partnerPhoneNumber: 'Telefonszám',
        companyRregistrationNumber: 'Cégjegyzékszám',
        offerType: 'Típus',
        implementationStartedAt: 'Megvalósítás éve'
      },
      description: {
        companyRregistrationNumber: 'BS-CF-NNNNNN formátumban.'
      },
      validation: {
        requiredField: 'Mező kitöltése kötelező!'
      },
      notification: {
        saveSuccess: 'Pályázati adatok mentése sikeres',
        saveError: 'Pályázati adatok mentése sikertelen',
        finalizeSuccess: 'Pályázati adatok véglegesítése sikeres',
        finalizeError: 'Pályázati adatok véglegesítése sikertelen'
      }
    },
    startImplementation: {
      dialog: {
        start: {
          title: 'Megvalósítás megkezdése',
          text: 'Biztosan megkezdi a megvalósítást?'
        }
      },
      notification: {
        startSuccess: 'Megvalósítás megkezdése sikeres',
        startError: 'Hiba a megvalósítás megkezdése során'
      }
    },
    offerType: {
      tender: 'Pályázatos',
      extra: 'Keretszerződés',
      maximap: 'maXI-MAP+ (demo)',
      subscription: 'mAXI-MAP előfizetés'
    },
    status: {
      offer_created: 'Projekt létrehozva',
      offer_accepted: 'Kitöltés alatt',
      user_filled: 'Véglegesítésre vár',
      finalized: 'Véglegesítve',
      contract_requested: 'Szállítási megállapodás igényelve',
      contract_signed: 'Szerződés aláírva',
      implementation_started: 'Megvalósítás megkezdve',
      implementation_completed: 'Megvalósítása teljesítve',
      maintenance_signed: 'Fenntartási szerződés aláírva',
      completed: 'Lezárt'
    },
    stats: {
      completed: 'Véglegesítve',
      unFinished: 'Kitöltendő',
      allUploadedArea: 'Összes rögzített terület'
    },
    dialog: {
      finalize: {
        title: 'Szerződés véglegesítése',
        text: 'Biztosan véglegesíti a szerződést?'
      },
      requestContract: {
        title: 'Szállítási megállapodás igénylése',
        text: 'Biztosan megrendeli a szolgáltatást?'
      },
      newOffer: {
        title: 'Új árajánlat igénylése',
        text: 'Biztosan új árajánlatot igényel?'
      },
      onBack: {
        title: 'Mentetlen adatok',
        text: 'Az űrlap mentetlen adatokat tartalmaz! Biztosan visszalép? Ezzel a mentetlen adatok elvesznek.'
      }
    },
    type: {
      tender: 'Pályázat',
      maximap: 'mAXI-MAP'
    }
  },

  parcel: {
    offer_select: 'Pályázatok',
    tableName: 'Tábla neve',
    tooltip: {
      archive: 'Archív',
      blocked: 'A tábla blokkolva. Frissítse a mAXI-MAP előfizetés csomagját, hogy a blokkolás feloldásra kerüljön',
      hasTender: 'Pályázatban szerepel',
      traditional: 'Hagyományos tábla'
    },
    stats: {
      allUploadedArea: 'Összes rögzített terület',
      areaFinalized: 'Véglegesített mennyiség'
    },
    header: {
      text: {
        noticeAreaSize:
          'Kérjük figyeljen oda, hogy az Ön által megadott táblák területe egyezzen meg a pályázathoz kiadott ajánlatunkban szereplő területmérettel.',
        noticeConsequence:
          'Ha kevesebb területet von be, kockáztathatja a pályázat megvalósulását. Ha több területet von be, az eredeti ajánlati árak felett plusz költsége jelentkezhet.',
        areaSizeBig:
          'Túl sok területet adott meg a Gazdasághoz. Módosítsa a tábla területeket, hogy a szerződött összterületet legfeljebb 5%-kal haladja meg.',
        areaSizeSmall: 'Töltse fel a Gazdaságot Táblákkal, hogy elérje a szerződött összterületet!',
        extraOfferTypeNotice: 'Keretszerződés esetében tetszőleges hektár mennyiségű tábla hozzárendelhető',
        ownAreaSizeBig:
          'Túl sok területet töltött fel. Módosítsa a tábla területeket, hogy az összterületet legfeljebb 5%-kal haladja meg a szerződött mennyiséget, vagy rendeljen hektár bővítést a mAXI-MAP előfizetés menüpont alatt.'
      }
    },
    own: {
      header: {
        name: 'Név',
        area: 'Terület',
        source: 'Táblahatár forrása',
        tender: 'Pályázatos',
        status: 'Alap adatok',
        proplantaStatus: 'Szaktanács státusz'
      }
    },
    unblockParcelModal: {
      header: {
        name: 'Tábla neve',
        area: 'Terület'
      },
      title: 'Blokkolás feloldása',
      areaLimitStatus: {
        over: 'Maximum a hektár limit mennyiségben oldhatók fel táblák',
        none: 'Tábla kiválasztása kötelező!',
        good: 'A választott összterület megfelelő mennyiségű az Igényelt területek mennyiségéhez képest.',
        under:
          'Kérjük figyeljen oda, hogy az Ön által kijelölt táblák területe érje el az árajánlatban szereplő mennyiséget. Ha kevesebb területet von be, kockáztathatja a pályázat megvalósulását.'
      },
      selectedParcels: 'Kiválaszott táblák'
    },
    attachModal: {
      title: 'Táblák csatolása',
      header: {
        name: 'Tábla neve',
        area: 'Terület',
        blockedBy: 'Inaktivitás oka'
      },
      areaLimitStatus: {
        over: 'A hektár limit feletti tábla csatolás nem lehetséges!',
        none: 'Tábla kiválasztása kötelező!',
        good: 'A választott összterület megfelelő mennyiségű az Igényelt területek mennyiségéhez képest.',
        under:
          'Kérjük figyeljen oda, hogy az Ön által kijelölt táblák területe érje el az árajánlatban szereplő mennyiséget. Ha kevesebb területet von be, kockáztathatja a pályázat megvalósulását.'
      },
      selectedParcels: 'Kiválaszott táblák'
    },
    downloadModal: {
      title: {
        outlines: 'Táblahatárok letöltése',
        soilSampleTemplate: 'Talajvizsgálat sablon letöltése'
      },
      label: {
        name: 'Tábla neve',
        area: 'Terület',
        selectAll: 'Összes kijelölése'
      }
    },
    attach: {
      inOtherTenderOffer: 'Másik pályázatos projektbe bevonva',
      notFinalized: 'Nem véglegesített'
    },
    filter: {
      state: 'Státusz',
      needAttention: 'Minden szerkesztendő',
      archived: 'Archív táblák megjelenítése',
      withoutTender: 'Pályázat nélkül',
      attachableOnly: 'Csak csatolhatók megjelenítése',
      traditionalOnly: 'Csak hagyományos'
    },
    status: {
      finalized: 'Véglegesítve',
      editing: 'Szerkesztés alatt',
      NEED_YEARLY_DATA: 'Javítás szükséges',
      waiting_for_finalization: 'Véglegesítésre vár',
      awaitingYieldData: 'Hozam adat megadható',
      awaitingHistoricalYieldData: 'Hozam adat megadandó',
      awaitingPlannedCropData: 'Tervezett növény megadandó',
      agroMapOrdered: 'Táblahatár megrendelve',
      agroMapCompleted: 'Táblahatár teljesítve'
    },
    parcelEdit: 'Tábla szerkesztése',
    list: {
      title: 'Táblák',
      header: {
        area: 'Terület',
        name: 'Tábla neve',
        source: 'Táblahatár',
        tender: 'Pályázatos',
        status: 'Alap adatok',
        state: 'Kitöltve',
        proplantaStatus: 'Szaktanács státusz'
      }
    },
    source: {
      vantageDraw: 'Rajzolt',
      vantageFileUpload: 'Fájlból',
      agroMap: 'AgroMAP'
    },
    messages: {
      info: {
        agroMap: 'Az agromap opcióhoz tartozó szöveg leírása.'
      },
      warning: {
        max: 'Nem megelelő hozam mennyiség! Max: {max}',
        min: 'Nem megelelő hozam mennyiség! Min: {min}'
      },
      validation: {
        parcelDates: 'Az aratás dátuma nem lehet korábbi a vetés dátumánál.'
      }
    },
    dialog: {
      finalize: {
        title: 'Tábla véglegesítése',
        exceededText: 'A tábla nem véglegesíthető mAXI-MAP előfizetés limit túllépés miatt.',
        text: 'Biztosan szeretné véglegesíteni a táblát? A tábla véglegesítésével felhasználásra kerül a mAXI-MAP előfizetés tábla területére eső mennyisége.'
      },
      removeParcel: {
        title: 'Tábla törlése',
        text: 'Biztos szeretné törölni a táblát?'
      },
      moveParcel: {
        title: 'Tábla áthelyezése',
        text: 'Tábla áthelyezése másik gazdaságba',
        farmName: 'Gazdaság neve',
        farmHint: 'A tábla csak olyan gazdaságba mozgatható át, aminél a szállítási megállapodás alá lett írva'
      },
      onBack: {
        title: 'Mentetlen adatok',
        text: 'Az űrlap mentetlen adatokat tartalmaz! Biztosan visszalép? Ezzel a mentetlen adatok elvesznek.'
      },
      yearlyData: {
        title: 'Éves adatok megadása',
        finalizeConfirmTitle: 'Véglegesítés',
        finalizeConfirmText:
          'Nincs kitöltve az idei éves adat, ezért a tábla "Véglegesített" állapot helyett "Tervezett növény megadandó" állapotra vált.',
        finalizeYieldOnlyConfirmText: 'Minden adat ki lett töltve, ezért a tábla "Véglegesített" állapotra vált.'
      },
      detachParcel: {
        title: 'Tábla lecsatolása',
        text: 'Biztosan szeretné lecsatolni a táblát?'
      }
    },
    map: {
      action: {
        draw: 'Polygon rajzolás',
        cut: 'Részlet kivágás',
        remove: 'Polygon törlése',
        upload: 'Tallózás',
        cancel: 'Mégsem'
      },
      error: {
        title: 'Térkép hiba',
        limitReached: 'Elérte a maximum polygon számot',
        tooLargeArea: 'Túl nagy területű polygon',
        tooMuchPolygon: 'Túl sok polygon van a térképen',
        tooMuchDistanceBetweenPolygons: 'Túl nagy a távolság a polygonok között',
        twoPolygonsAreInTouch: 'Átfedés van a polygonok között',
        polygonOverlapsWithinUserTender: 'Átfedés van a felhasználó egy másik táblájának polygonok között',
        polygonOverlapsWithinTender: 'Átfedés van egy másik tábla polygonjai között'
      },
      hint: {
        title: 'Jelmagyarázat',
        error: 'Hibás polygon',
        actual: 'Aktuális táblához tartozó polygon',
        other: 'Másik, nem véglegesített táblához tartozó polygon',
        finished: 'Másik, véglegesített táblához tartozó polygon',
        archived: 'Archív táblához tartozó polygon'
      }
    },
    yearlyData: {
      notification: {
        saveSuccess: 'Éves adatok mentése sikeres',
        saveError: 'Éves adatok mentése sikertelen',
        finalizeSuccess: 'Éves adatok véglegesítése sikeres',
        finalizeError: 'Éves adatok véglegesítése sikertelen'
      }
    },
    details: {
      areaLimitExceededWarning:
        'A tábla nem véglegesíthető mAXI-MAP modul limit túllépés miatt. Amennyiben további területet szeretne bevonni, előfizetés hiányában kérjük keresse területi képviselőjét. Ha pedig már rendelkezik előfizetéssel, kérjük bővítse a területkorlátot a mAXI-MAP előfizetés fül alatt.',
      mapInfo:
        '<p>Kérjük, az agronómiai vonatkozású adatokat- táblaméret, termesztett növény, hozam – a lehető legpontosabban, a konkrét táblára vonatkozóan adja meg!</p><p> Ez jelentősen befolyásolhatja a szolgáltatásokkal előállításra kerülő adatok pontosságát, ezáltal gazdálkodásának sikerét az elkövetkező években.</p><p> Ha pl. a tábla területét 5% hibával, a hozamot 3% hibával adjuk meg, máris 8% hibával kell számolnunk.</p>',
      mapError: 'Hibák vannak a térképen!',
      mapWarning: 'Nincsenek polygonok a térképen',
      mapInfoLabel: 'Információ',
      label: {
        tableName: 'Tábla neve',
        settlement: 'Település neve',
        parcelNumber: 'Helyrajzi szám',
        currentCrop: 'Aktuális évi növénykultúra',
        area: 'Terület (nyilvántartott)',
        uploadedArea: 'Terület (vektorból mért)',
        source: 'Táblahatár',
        ekTableNumber: 'E.K. szerinti táblaszám',
        blockId: 'Blokk azonosító',
        sharedCropping: 'Osztott művelés',
        comment: 'Megjegyzések',
        yearYield: 'Hozam adatok',
        yieldsData: '<h2>Hozam adatok</h2>',
        yield: '<h3>Hozam adatok - {year}</h3>',
        earlierCrop: 'Növény',
        year: 'Év',
        hozam: 'Hozam',
        plantingDate: 'Vetés dátuma',
        harvestDate: 'Aratás dátuma',
        onlyPlannedCrop: 'Csak tervezett növény megadása',
        farmingModePrecision: 'Precíziós gazdálkodás',
        farmingModeTraditional: 'Hagyományos gazdálkodás'
      },
      items: {
        upload: 'Feltöltés',
        draw: 'Rajzolás',
        agroMap: 'AgroMAP'
      },
      description: {
        uploaded_area: 'Egy tábla maximális területe 500 ha lehet.',
        source:
          'Kérjük alaposan vegye figyelembe, hogy melyik opciót választja a felkínált lehetőségek közül, mert ezek az adatok képezik a szolgáltatás megvalósulása alatt a teljes projekt alapját. A megrendelt szolgáltatások (pl: zónázás, talajmintavétel, szaktanácsadás) ezekre a megadott területekre fognak elkészülni.',
        parcelNumber:
          'Több érték is megadható. Érték rögzítése: ENTER billentyű. Formátum: XX, XX-XX, XX/XX, XX/XX-XX.',
        currentCrop: 'A növényt kizárólag a gépelés közben legördülő listából tudja kiválasztani',
        comment: 'Max. 256 karakter.',
        ekTableNumber:
          'Egybevont táblák esetén a táblaszámokat külön rögzítse. Érték rögzítése: ENTER billentyű. A területekhez tartozó "Egységes kérelem" dokumentum feltöltésére a szolgáltatás megrendelésekor lesz lehetősége.',
        yield: '{year} évre vonatkozó hozam adatok.'
      },
      validator: {
        harvestDate: {
          invalidMessage: 'Az aratás dátuma nem lehet korábbi mint a vetésé'
        },
        yieldAmount: {
          invalidMessage: 'Nem megfelelő hozam mennyiség! Min: {min}, Max: {max}'
        },
        plantingDate: {
          invalidMessage: 'Az vetés dátuma nem lehet későbbi mint az aratásé'
        },
        ekNumbers: {
          invalidMessage: 'Mező kitöltése kötelező'
        },
        parcelArea: {
          invalidMessage: 'A nyilvántartott terület és a vektorból mért terület között maximum 10% eltérés lehetséges'
        }
      },
      notification: {
        saveSuccess: 'Tábla adatok mentése sikeres',
        saveError: 'Tábla adatok mentése sikertelen',
        finalizeSuccess: 'Tábla adatok véglegesítése sikeres',
        finalizeError: 'Tábla adatok véglegesítése sikertelen'
      },
      baseData: 'Alap adatok',
      proplanta: 'Szaktanács'
    },
    notification: {
      removeSuccess: 'Tábla törlése sikeres',
      removeError: 'Hiba a tábla törlése közben',
      moveSuccess: 'Tábla áthelyezése sikeres',
      moveError: 'Hiba a tábla áthelyezése közben',
      detachSuccess: 'Tábla lecsatolása sikeres',
      detachError: 'Tábla lecsatolása sikertelen',
      soilTemplateDownloadSuccess: 'Talajvizsgálat sablon letöltése elindítva'
    },
    sourceChange: {
      title: 'Táblahatár váltás',
      text: 'A táblahatár módosítása esetén a térkép adatok törlődnek. Biztos, hogy végrehajtja a műveletet?'
    },
    farmingModeChange: {
      title: 'Váltás precíziós gazdálkodásra',
      text: 'Biztos módosítja a táblát precíziós gazdálkodásra? Ha elfogadja, akkor nem tudja visszaállítani hagyományos gazdálkodásra.'
    }
  },
  proplanta: {
    soilTreatmentData: 'Talajkezelési adatok',
    baseData: 'Alapadatok',
    label: {
      soil: 'Termelőhely',
      nitrateSensitive: 'Nitrátérzékeny',
      actualYear: 'Gazdasági év',
      akgProgram: 'AKG program',
      plant: 'Termeszthető növény',
      plannedYears: 'Termesztés tervezett hossza',
      year: 'év',
      amount: 't/ha',
      kgAmount: 'kg/ha',
      plantAge: 'Növény kora',
      plannedYield: 'Tervezett főtermés',
      preCrop: 'Elővetemény',
      preCropHarvestDate: 'Elővetemény 09/15 előtt betakarítva',
      preCropHarvestDateAnswer: {
        yes: 'Előtt',
        no: 'Után'
      },
      preCropYield: 'Elővetemény főtermése',
      byProduct: 'Elővetemény melléktermése',
      fateOfByProduct: 'Melléktermés sorsa',
      fateOfByProductAnswer: {
        yes: 'Maradt',
        no: 'Lekerült'
      },
      legumePreCropPlow: 'Évelő pillangós két éve kiszántva',
      legumePreCrop: 'Évelő pillangós növény',
      nThisYear: 'Ebben a gazdasági évben már kijuttatott N hatóanyag',
      pThisYear: 'Ebben a gazdasági évben már kijuttatott P hatóanyag',
      kThisYear: 'Ebben a gazdasági évben már kijuttatott K hatóanyag',
      treatment: {
        fertilizations: '<h3>Istállótrágyázás</h3>',
        slurries: '<h3>Hígtrágyázás</h3>',
        year: 'Éve',
        type: 'Típusa',
        amount: 'Adagja'
      }
    },
    hint: {
      plantAge: '(év, 0=telepítés előtt)'
    },
    status: {
      finalized: 'Véglegesítve',
      editing: 'Szerkesztés alatt',
      waiting_for_finalization: 'Véglegesítésre vár',
      parcel_not_finalized: 'Tábla nincs véglegesítve',
      need_yearly_data: 'Javítás szükséges'
    },
    dialog: {
      finalize: {
        title: 'Szaktanács adatok véglegesítése',
        text: 'Biztosan véglegesíti a Szaktanács adatokat? <br><strong>Kérem vegye figyelembe, hogy tud megadni talajkezelési adatokat is a pontosabb szaktanács elkészítéséhez.</strong> <br> A Talajkezelési adatokat a Szaktanács űrlap második lépésében a Talajkezelési adatok fülre kattintva adhatja meg. A Szaktanács űrlap véglegesítésekor a rendszer automatikusan átnavigálta.',
        confirm: 'Véglegesítés',
        cancel: 'Szerkesztés folytatása'
      }
    },
    notification: {
      saveSuccess: 'Szaktanács adatok mentése sikeres',
      saveError: 'Szaktanács adatok mentése sikertelen',
      finalizeSuccess: 'Szaktanács adatok véglegesítése sikeres',
      finalizeError: 'Szaktanács adatok véglegesítése sikertelen'
    },
    validator: {
      otherTreatmentRequired: {
        invalidMessage: 'Adott évhez az összes adat kitöltése szükséges'
      },
      otherTreatmentYear: {
        invalidMessage: 'Évenként egy típushoz csak egy adatt vihető fel'
      },
      treatmentRequired: {
        invalidMessage: 'Adott évhez az összes adat kitöltése szükséges'
      },
      treatmentYear: {
        invalidMessage: 'Évenként egy típushoz csak egy adatt vihető fel'
      }
    }
  },
  customer: {
    details: {
      label: {
        name: 'Név',
        email: 'Email',
        status: 'Státusz',
        delegate: 'Területi képviselő'
      }
    },
    list: {
      header: {
        name: 'Név',
        email: 'Email cím',
        status: 'Státusz',
        delegate: 'Területi képviselő'
      }
    },
    status: {
      active: 'Aktív',
      inactive: 'Inaktív'
    },
    filter: {
      status: 'Státusz szűrő'
    },
    dialog: {
      onBack: {
        title: 'Mentetlen adatok',
        text: 'Az űrlap mentetlen adatokat tartalmaz! Biztosan visszalép? Ezzel a mentetlen adatok elvesznek.'
      }
    }
  },
  productGroup: {
    label: {
      ekPdf: 'Egységes kérelem pdf'
    },
    html: {
      loadingError: 'Hiba történt az információs blokk betöltése során'
    },
    sendedData: 'Továbbadott adatok',
    parcels: 'Táblák',
    noParcels: 'Nincsenek táblák',
    noAgromapParcels: 'Nincs tábla AgroMap táblahatár forrással',
    parcel: {
      name: 'Tábla neve',
      area: 'Terület',
      tender: 'Pályázatos',
      cropCode: 'Növény',
      hasOrder: 'Van már rendelése adott táblára az évben?',
      orders: 'Volt már rendelve',
      alreadyHasOrder: 'Igen',
      orderabilityTab: {
        orderable: 'Rendelhető',
        missingPrerequisite: 'Előfeltétel hiányzik',
        missingData: 'Adat hiányzik '
      },
      allHectare: 'Összes hektár:',
      fullPrice: 'Teljes ár:',
      filter: {
        search: 'Keresés',
        crop: 'Növény',
        withoutTender: 'Pályázat nélkül'
      },
      areaLimitStatus: {
        none: 'Tábla kiválasztása kötelező!',
        good: 'A választott összterület megfelelő mennyiségű az Igényelt területek mennyiségéhez képest.',
        under:
          'Kérjük figyeljen oda, hogy az Ön által kijelölt táblák területe érje el az árajánlatban szereplő mennyiséget. Ha kevesebb területet von be, kockáztathatja a pályázat megvalósulását.',
        over: 'A választott összterület legfeljebb 5%-kal haladhatja meg az Igényelt terület mennyiségét. Lehetősége van több terület bevonására, de ebben az esetben ez az eredeti ajánlati árak felett plusz költséget jelent.'
      },
      blockedBy: 'Nem rendelhető ok',
      crops: 'Növények',
      parcelOrderInfo: {
        cannotOrderReason: 'Nem rendelhető ok',
        ordered: 'Megrendelés: {orderDate}',
        missingCrop: 'Hiányzó növény',
        noPreviousYield: 'Előző évi hozam adat nincs megadva',
        noZoningOrdered: 'Nincs zónázás rendelve'
      },
      headFertilizationDate1: '1. Fejtrágyázás dátuma',
      headFertilizationDate2: '2. Fejtrágyázás dátuma'
    },
    offer: {
      partnerName: 'Megrendelő neve',
      address: 'Címe',
      phoneNumber: 'Telefonszáma',
      email: 'Email címe',
      taxNumber: 'Adószám/adóazonosító jel',
      companyRegistrationNumber: 'Cégjegyzékszám'
    },
    validator: {
      allRequired: 'Összes elfogadása kötelező!',
      parcelSelectionRequired: 'Legalább egy tábla kiválasztása kötelező!'
    }
  },
  product: {
    unitType: {
      hectare: 'ha',
      piece: 'db',
      area: 'ha'
    },
    name: 'Szolgáltatás neve',
    offerAmount: 'Projektben szereplő mennyiség'
  },

  subscription: {
    tabs: {
      baseData: 'Alapadatok',
      area: 'Kezelt területek'
    },
    label: {
      tenders: 'Pályázatos projektek',
      nextYearOffers: 'Következő évi előfizetés',
      activeOffers: 'Aktív előfizetések',
      previousYearOffers: 'Korábbi előfizetések'
    },
    order: {
      list: {
        header: {
          name: 'Név',
          area: 'Terület',
          orderDate: 'Rendelés dátuma',
          status: 'Státusz'
        }
      },
      status: {
        upcoming: {
          completed: 'Fizetve',
          inProgress: 'Fizetendő',
          canceled: 'Lezárt'
        },
        current: {
          completed: 'Aktív',
          inProgress: 'Fizetendő',
          canceled: 'Lezárt'
        },
        past: {
          completed: 'Lejárt',
          inProgress: 'Fizetendő',
          canceled: 'Lezárt'
        }
      }
    },
    offer: {
      list: {
        header: {
          name: 'Név',
          area: 'Terület',
          maintenanceEndsAt: 'Fenntartási időszak vége'
        }
      }
    },
    header: {
      tooltip: {
        extensionBlockedErrorAlert:
          'A mAXI-MAP előfizetés évforduló váltás előtti hónapban nem lehet bővítést rendelni. Az évforduló váltás után erre ismét lesz lehetőség',
        limit:
          'Ez a teljes véglegesíthető hektár mennyiség, ami a mAXI-MAP előfizetés megrendelések és pályázati szerződések összegéből áll. Csak a fizetett megrendelések számítanak bele a limitbe.',
        renewalDate:
          'Eddig a dátumig él a mAXI-MAP előfizetése. Ekkortól frissítenie kell a megrendelést, hogy zavartalanul használhassa a mAXI-MAP szolgáltatásokat.'
      },
      label: {
        limit: 'Hektár limit',
        renewalDate: 'Évforduló',
        hectare: 'ha'
      },
      extendModal: {
        title: 'Extra hektár rendelés',
        label: {
          name: 'Csomag neve',
          desc: 'Csomag laírása',
          price: 'Egységár',
          priceText: ' Ft / hektár (évente)',
          area: 'Rendelt mennyiség',
          yearlypriceText: 'Rendelési összeg (évente):'
        }
      }
    },
    extend: {
      validator: {
        allRequired: 'Összes elfogadása kötelező!'
      }
    }
  },

  label: {
    yes: 'Igen',
    no: 'Nem',
    acknowledge: 'Tudomásul veszem'
  },

  button: {
    edit: 'Szerkesztés',
    open: 'Megtekintés',
    delete: 'Törlés',
    move: 'Áthelyezés',
    downloadOffer: 'Árajánlat letöltése',
    downloadContract: 'Szállítási megállapodás letöltése',
    requestDeliveryContract: 'Szállítási megállapodás igénylése',
    requestNewOffer: 'Új árajánlat igénylése',
    requestSubscription: 'mAXI-MAP előfizetés igénylése',
    save: 'Mentés',
    finalize: 'Véglegesítés',
    back: 'Vissza',
    addNewTable: 'Új tábla felvétele',
    addAgromapOrder: 'Táblahatár rendelés leadása',
    unblockParcels: 'Blokkolás feloldása',
    order: 'Megrendelés',
    placeOrder: 'Megrendelem',
    closeOrder: 'Lezárás',
    cancel: 'Mégse',
    proplanta: 'Szaktanács megtekintés',
    yearlyData: 'Éves adat megadása',
    attachParcel: 'Tábla csatolása',
    detachParcel: 'Tábla lecsatolása',
    extend: 'Extra hektár rendelés',
    startImplementation: 'Megvalósítás megkezdése',
    downloadMaintenance: 'Fenntartási szerződés letöltése',
    downloadParcelOutlines: 'Táblahatárok letöltése',
    downloadSoilSampleTemplate: 'Talajvizsgálat sablon letöltése',
    downloads: 'Letöltések',
    download: 'Letöltés'
  },

  filter: {
    search: 'Keresés'
  },
  webshop: {
    categoryCard: {
      btn: {
        front: 'További információk',
        back: 'Tovább'
      }
    }
  },
  validator: {
    parcelFormTableBlockRequired: {
      invalidMessage: 'A dátum megadása kötelező',
      dateMustBeAfterLastOrderMessage:
        'A dátumnak későbbinek kell lennie, mint a legutolsó rendelésnél megadott dátum ({lastDate})'
    },
    parcelFormTableBlocSecondDate: {
      invalidMessage: 'A dátum nem lehet megegyező, vagy korábbi mint az első dátum'
    }
  }
};
